import React, { Component } from 'react';

class FormIcon extends Component {
  render() {
    return (
      <svg version="1.1" baseProfile="basic" x="0px" y="0px" width="32px" height="32px"
        viewBox="0 0 128 128" space="preserve">
        <path transform="matrix(0.128,0,0,0.128,0,0)" stroke="none" fill="#999999" d="M 872 0 L 851 0 L 745 0 L 724 0 L 0 0 L 0 141 L 0 162 L 0 1000 L 1000 1000 L 1000 162 L 1000 141 L 1000 0 L 872 0 z M 893 41 L 958 41 L 958 120 L 893 120 L 893 41 z M 766 41 L 830 41 L 830 120 L 766 120 L 766 41 z M 41 41 L 703 41 L 703 120 L 41 120 L 41 41 z M 979 979 L 20 979 L 20 162 L 724 162 L 745 162 L 851 162 L 872 162 L 979 162 L 979 979 z M 590 481 L 681 481 L 681 523 L 590 523 L 590 481 M 318 661 L 409 661 L 409 703 L 318 703 L 318 661 M 454 563 L 545 563 L 545 604 L 454 604 L 454 563 M 479 398 L 520 398 L 520 542 L 479 542 L 479 398 M 615 398 L 657 398 L 657 460 L 615 460 L 615 398 M 342 398 L 384 398 L 384 640 L 342 640 L 342 398 M 615 544 L 657 544 L 657 770 L 615 770 L 615 544 M 342 724 L 384 724 L 384 770 L 342 770 L 342 724 M 479 625 L 520 625 L 520 770 L 479 770 L 479 625" />
      </svg>
    );
  }
}

export default FormIcon;


// WEBPACK FOOTER //
// ./src/Components/FormIcon.jsx